import { api } from "./configs/axiosConfigs"

export const StoreAPI = {
    
    getStore: async (data:any) => {
        const response = await api.get(
            '/store', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createStore: async (data: any) => {
        const response = await api.post(
            '/store/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editStore: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/store/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    changeStatusStore: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/store/changeStatus/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteStore: async (idstore: number) => {
        const response = await api.delete(
            `/store/${idstore}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}